import React, { useState } from 'react'
import { OrderedListOutlined, } from '@ant-design/icons/lib/icons';
import { IconButton, TextField, Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
import AddAlarmIcon from '@mui/icons-material/AddAlarm';
import NotificationsIcon from '@mui/icons-material/Notifications';
import DeleteIcon from '@mui/icons-material/Delete';
import SettingsIcon from '@mui/icons-material/Settings';
import SearchIcon from '@mui/icons-material/Search';
import ToggleOnIcon from '@mui/icons-material/ToggleOn';
import ToggleOffIcon from '@mui/icons-material/ToggleOff';
import EditIcon from '@mui/icons-material/Edit';
import CustomPagination from '../general/CustomPagination';
import CustomButton from '../general/CustomButton';
import CustomCheck from '../general/CustomCheck';
import UserService from '../../../services/user';
import NotificationConfigService from '../../../services/notificationConfig';
import { sortDataList, } from '../../../utils/function';
import { CODES } from '../../../utils/codesHTTP';
import _ from 'lodash';
import { simpleAlerts } from '../../../utils/alerts';

const columns = [
    { id: '#', label: '#', width: 30, align: 'center', },
    { id: 'numdoc', label: 'Doc.', width: 80, align: 'center', order: true, },
    { id: 'trabajador', label: 'Trabajador', width: 200, align: 'left', order: true, },
    { id: 'usuario', label: 'Usuario', width: 80, align: 'center', order: true, },
    { id: 'desPerfil', label: 'Perfil', width: 80, align: 'center', order: true, },
    { id: 'actions', label: 'actions', width: 80, align: 'center' },
    { id: 'sel', label: 'seleccionar', width: 25, align: 'center' },
];

const BodyUsers = (props) => {
    const { forCheckBody, page, setPage, totalPage, data, setData, search, setSearch, editInfo, getInfo, dataSel, setDataSel, } = props;

    const [openNotificationModal, setOpenNotificationModal] = useState(false);
    const [notificationUser, setNotificationUser] = useState(null);
    const [dataClocks, setDataClocks] = useState(null);
    const [notificationConfigs, setNotificationConfigs] = useState([]);
    const [notificationConfig, setNotificationConfig] = useState({
        usuario_id: null,
        tipo_alerta: 'disconnect',
        canal_alerta: 'email',
        reloj_id: null,
        habilitado: true,
    });
    const [newNotificationConfigs, setNewNotificationConfigs] = useState([]);

    const handleOpenNotification = (user) => {
        setNotificationUser(user);
        setNotificationConfig({
            usuario_id: user?.id_usuario,
            tipo_alerta: 'disconnect',
            canal_alerta: 'email',
            reloj_id: null,
            habilitado: true,
        });
        setNewNotificationConfigs([]);
        getDataClocks();
        getNotificationConfigs(user?.id_usuario);
        setOpenNotificationModal(true);
    };

    const getDataClocks = async () => {
        try {
            const ClockService = require('../../../services/clock').default;
            const result = await ClockService.getRelojes();
            if (result.status === CODES.SUCCESS_200) {
                setDataClocks(result?.data);
            }
        } catch (error) {
            console.log(`Error en getDataClocks: ${error}`);
        }
    };

    const getNotificationConfigs = async (userId) => {
        try {
            const result = await NotificationConfigService.getConfigs(userId);
            if (result.status === CODES.SUCCESS_200) {
                setNotificationConfigs(result?.data || []);
            }
        } catch (error) {
            console.log(`Error en getNotificationConfigs: ${error}`);
        }
    };

    const deleteNotificationConfig = async (configId) => {
        try {
            const result = await NotificationConfigService.deleteConfig(configId);
            if (result.status === CODES.SUCCESS_200) {
                simpleAlerts({ message: 'Configuración eliminada!', type: 'success' });
                getNotificationConfigs(notificationUser?.id_usuario);
            } else {
                simpleAlerts({ message: 'Error al eliminar', type: 'error' });
            }
        } catch (error) {
            console.log(`Error en deleteNotificationConfig: ${error}`);
        }
    };

    const toggleNotificationConfig = async (configId) => {
        try {
            const result = await NotificationConfigService.toggleConfig(configId);
            if (result.status === CODES.SUCCESS_200) {
                simpleAlerts({ message: 'Configuración actualizada!', type: 'success' });
                getNotificationConfigs(notificationUser?.id_usuario);
            } else {
                simpleAlerts({ message: 'Error al actualizar', type: 'error' });
            }
        } catch (error) {
            console.log(`Error en toggleNotificationConfig: ${error}`);
        }
    };

    const handleCloseNotification = () => {
        setOpenNotificationModal(false);
        setNotificationUser(null);
        setNotificationConfig({
            tipo_alerta: 'disconnect',
            canal_alerta: 'email',
            reloj_id: null,
            habilitado: true,
        });
    };

    const handleNotificationConfigChange = (field, value) => {
        setNotificationConfig(prev => ({
            ...prev,
            [field]: value
        }));
    };

    const addNewNotificationRow = () => {
        const newRow = {
            id: Date.now(),
            usuario_id: notificationUser?.id_usuario,
            tipo_alerta: 'disconnect',
            canal_alerta: 'email',
            reloj_id: null,
            habilitado: true,
        };
        setNewNotificationConfigs(prev => [...prev, newRow]);
    };

    const updateNewNotificationConfig = (id, field, value) => {
        setNewNotificationConfigs(prev =>
            prev.map(config =>
                config.id === id ? { ...config, [field]: value } : config
            )
        );
    };

    const removeNewNotificationConfig = (id) => {
        setNewNotificationConfigs(prev => prev.filter(config => config.id !== id));
    };

    const saveNotificationConfig = async () => {
        if (newNotificationConfigs.length === 0) {
            simpleAlerts({ message: 'Agregue al menos una configuración', type: 'warning' });
            return;
        }

        try {
            let savedCount = 0;
            for (const config of newNotificationConfigs) {
                const { id, ...configData } = config;
                const result = await NotificationConfigService.createConfig(configData);
                if (result.status === CODES.CREATE_201 || result.status === CODES.SUCCESS_200) {
                    savedCount++;
                } else {
                    simpleAlerts({ message: `Error al guardar configuración: ${result?.response?.data?.message}`, type: 'error' });
                }
            }
            if (savedCount === newNotificationConfigs.length) {
                simpleAlerts({ message: `${savedCount} configuración(es) guardada(s) correctamente!`, type: 'success' });
                setNewNotificationConfigs([]);
                getNotificationConfigs(notificationUser.id_usuario);
            } else if (savedCount > 0) {
                simpleAlerts({ message: `${savedCount} de ${newNotificationConfigs.length} configuraciones guardadas`, type: 'warning' });
            }
        } catch (error) {
            console.log(`Error en saveNotificationConfig: ${error}`);
            simpleAlerts({ message: 'Error al guardar las configuraciones', type: 'error' });
        }
    };

    // /** inicio ordenamiento de columnas */
    const [sortConfigTable, setSortConfigTable] = useState({ key: null, direction: "ascending", });
    const handleSortTable = (key) => {
        let direction = "ascending";
        if (sortConfigTable && sortConfigTable.key === key && sortConfigTable.direction === "ascending") {
            direction = "descending";
        }
        setSortConfigTable({ key, direction });
    };
    const srtdData = sortDataList(data, sortConfigTable);
    // /** fin ordenamiento de columnas */

    const handleChangeGeneral = (checked) => {
        let newData;
        if (checked)
            newData = data;
        else
            newData = [];
        return setDataSel(newData);
    }

    const handleChangeCheck = (checked, info) => {
        let newData = _.cloneDeep(dataSel);
        if (checked) {
            newData.push(info);
        } else {
            newData = newData.filter((e) => e.id_usuario !== info.id_usuario);
        }
        return setDataSel(newData);
    }

    const handleKeyPress = (e) => {
        if (e.key === 'Enter' && getInfo) {
            getInfo();
        }
    };

    const saveUser = async (info, key, value) => {
        info[key] = value;
        const indexToUpdate = data.findIndex(item => +item.id_usuario === +info.id_usuario);
        const newData = _.cloneDeep(data);
        newData[indexToUpdate] = { ...info };
        try {
            const result = await UserService.register(info);
            if (result.status === CODES.CREATE_201) {
                simpleAlerts({ message: result?.data?.message || "Actualizado!", type: "success" });
                setData(newData);
            } else {
                simpleAlerts({ message: result?.response?.data?.error || result?.response?.data?.message || "No se pudo actualizar usuario!", type: "error" });
            }
        } catch (error) {
            console.log(`Error en register: ${error}`);
        }
    }

    return (
        <>
            <TextField
                hiddenLabel
                id="filled-hidden-label-small"
                placeholder='Busqueda por documento / trabajador / usuario'
                variant="filled"
                size="small"
                fullWidth
                InputProps={{
                    endAdornment: (
                        <IconButton color='primary' style={{ padding: 2, border: 'solid 1px' }}
                            onClick={getInfo}
                        >
                            <SearchIcon fontSize='small' />
                        </IconButton>
                    ),
                    style: { fontSize: 12, },
                }}
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                onKeyPress={handleKeyPress}
                className='textField-search'
                inputProps={{ style: { fontSize: 12, color: 'black', fontWeight: 'bold', }, }}
            />
            <div className="table-body-frame">
                <div className="table-body">
                    <table className='table table-striped table-hover table-bordered table-sm'>
                        <thead className='sticky-top order-1' style={{ whiteSpace: 'nowrap' }}>
                            <tr className="table-header table-dark">
                                {columns.map((col) => (
                                    <th
                                        key={col.id}
                                        className={`${col.align} ${col.order && 'sortable'} th-table-head`}
                                        style={{ width: col.width, maxWidth: col.width, }}
                                        onClick={() => col.order && handleSortTable(col.id)}
                                    >
                                        {col.id === 'actions' ?
                                            <span className="actions-icon">
                                                <SettingsIcon style={{ fontSize: 'medium' }} />
                                            </span>
                                            : col.id === 'sel' ?
                                                <div style={{ marginTop: '-1rem' }}>
                                                    <CustomCheck
                                                        forCheck={`checkbox-title-body${forCheckBody}`}
                                                        checked={(dataSel?.length === data?.length && dataSel?.length > 0) ? true : false}
                                                        onChange={(e) => handleChangeGeneral(e.target.checked)}
                                                    />
                                                </div>
                                                : <>
                                                    {col.label}
                                                    {col.order && <span className="sort-icon"><OrderedListOutlined /></span>}
                                                </>}
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody className="table-group-divider">
                            {srtdData?.map((row, idxRow) => {
                                return (
                                    <tr
                                        key={"row" + idxRow}
                                        className={+row?.id_estado !== 1 ? 'table-danger' : ''}
                                    >
                                        {columns.map((col, indexColumn) => {
                                            const value = row[col.id];
                                            return (
                                                <td
                                                    key={'col' + indexColumn}
                                                    className={`${col.align}`}
                                                    style={{ width: col.width, maxWidth: col.width, }}
                                                >
                                                    {col.id === 'sel' ?
                                                        <CustomCheck
                                                            forCheck={`${row.id_usuario}${forCheckBody}`}
                                                            checked={(dataSel?.find(e => e.id_usuario === row.id_usuario) ? true : false)}
                                                            onChange={(e) => handleChangeCheck(e.target.checked, row)}
                                                        />
                                                        : col.id === 'actions' ?
                                                            <div className='d-flex justify-content-evenly'>
                                                                <IconButton
                                                                    aria-label="notifications"
                                                                    size="small"
                                                                    style={{ border: 'solid 1px', padding: '0px 1px', borderRadius: 2 }}
                                                                    color={'info'}
                                                                    onClick={() => handleOpenNotification(row)}
                                                                    title='Enviar notificación'
                                                                >
                                                                    <NotificationsIcon fontSize="inherit" />
                                                                </IconButton>
                                                                <IconButton
                                                                    aria-label="active"
                                                                    size="small"
                                                                    style={{ border: 'solid 1px', padding: '0px 1px', borderRadius: 2 }}
                                                                    color={'warning'}
                                                                    onClick={() => editInfo(row, 2)}
                                                                    title={(+row.id_estado === 1 ? 'Desactivar Reloj' : 'Activar Reloj')}
                                                                >
                                                                    <AddAlarmIcon fontSize="inherit" />
                                                                </IconButton>
                                                                <CustomButton
                                                                    title='Editar Usuario'
                                                                    variant={'primary'}
                                                                    value={<EditIcon style={{ fontSize: '15px' }} />}
                                                                    onClick={() => editInfo(row, 1)}
                                                                />
                                                                <IconButton
                                                                    aria-label="active"
                                                                    size="small"
                                                                    style={{ border: 'solid 1px', padding: '0px 1px', borderRadius: 2 }}
                                                                    color={+row.id_estado === 1 ? 'error' : 'success'}
                                                                    onClick={() => saveUser(row, 'id_estado', (+row.id_estado === 1 ? 2 : 1))}
                                                                    title={(+row.id_estado === 1 ? 'Desactivar Reloj' : 'Activar Reloj')}
                                                                >
                                                                    {+row.id_estado === 1 ? <ToggleOffIcon fontSize="inherit" /> : <ToggleOnIcon fontSize="inherit" />}
                                                                </IconButton>
                                                            </div>
                                                            : col.id === '#' ?
                                                                row.id_usuario
                                                                : value}
                                                </td>
                                            );
                                        })}
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
                {totalPage > 1 &&
                    < div className="table-footer">
                        <CustomPagination
                            totalPages={totalPage}
                            page={page}
                            setPage={setPage}
                        />
                    </div>
                }
            </div >
            <Dialog open={openNotificationModal} onClose={handleCloseNotification} maxWidth="lg" fullWidth>
                <DialogTitle>Configurar Alertas de Notificación</DialogTitle>
                <DialogContent>
                    {notificationUser && (
                        <div style={{ paddingTop: '16px' }}>
                            <div style={{ marginBottom: '20px', padding: '12px', backgroundColor: '#f5f5f5', borderRadius: '4px' }}>
                                <p style={{ margin: '4px 0' }}><strong>Usuario:</strong> {notificationUser.usuario}</p>
                                <p style={{ margin: '4px 0' }}><strong>Trabajador:</strong> {notificationUser.trabajador}</p>
                                <p style={{ margin: '4px 0' }}><strong>Documento:</strong> {notificationUser.numdoc}</p>
                            </div>

                            {/* Unified Configs Table */}
                            <div style={{ overflowX: 'auto', marginBottom: '20px' }}>
                                <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '12px' }}>
                                    <thead>
                                        <tr style={{ backgroundColor: '#e0e0e0' }}>
                                            <th style={{ padding: '8px', border: '1px solid #ccc', minWidth: '120px' }}>Tipo Alerta</th>
                                            <th style={{ padding: '8px', border: '1px solid #ccc', minWidth: '100px' }}>Canal</th>
                                            <th style={{ padding: '8px', border: '1px solid #ccc', minWidth: '150px' }}>Reloj</th>
                                            <th style={{ padding: '8px', border: '1px solid #ccc', minWidth: '80px' }}>Estado</th>
                                            <th style={{ padding: '8px', border: '1px solid #ccc', minWidth: '80px', textAlign: 'center' }}>Acciones</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {/* Existing Configs */}
                                        {notificationConfigs && notificationConfigs.length > 0 && notificationConfigs.map((config) => (
                                            <tr key={`existing-${config.id_notificacion}`} style={{ backgroundColor: '#fafafa' }}>
                                                <td style={{ padding: '8px', border: '1px solid #ccc' }}>
                                                    {config.tipo_alerta === 'disconnect' ? 'Desconexión' : config.tipo_alerta === 'reconnect' ? 'Reconexión' : 'Sin Marcas'}
                                                </td>
                                                <td style={{ padding: '8px', border: '1px solid #ccc' }}>Email</td>
                                                <td style={{ padding: '8px', border: '1px solid #ccc' }}>
                                                    {!config.reloj_id ? 
                                                        <strong style={{ color: '#2196F3' }}>Todos</strong> 
                                                        : config.reloj?.serial 
                                                            ? `${config.reloj.serial} - ${config.reloj.descripcion || ''}`.trim()
                                                            : (dataClocks?.find(c => c.id_reloj === config.reloj_id)?.serial || `ID: ${config.reloj_id}`)}
                                                </td>
                                                <td style={{ padding: '8px', border: '1px solid #ccc' }}>
                                                    <CustomCheck
                                                        forCheck={`config-enabled-${config.id_notificacion}`}
                                                        checked={config.habilitado}
                                                        onChange={() => toggleNotificationConfig(config.id_notificacion)}
                                                    />
                                                </td>
                                                <td style={{ padding: '8px', border: '1px solid #ccc', textAlign: 'center' }}>
                                                    <IconButton
                                                        size="small"
                                                        color="error"
                                                        onClick={() => deleteNotificationConfig(config.id_notificacion)}
                                                        title="Eliminar"
                                                    >
                                                        <DeleteIcon fontSize="small" />
                                                    </IconButton>
                                                </td>
                                            </tr>
                                        ))}

                                        {/* New Unsaved Configs */}
                                        {newNotificationConfigs && newNotificationConfigs.length > 0 && newNotificationConfigs.map((config) => (
                                            <tr key={`new-${config.id}`} style={{ backgroundColor: '#fffacd', borderTop: '2px solid #ffc107' }}>
                                                <td style={{ padding: '8px', border: '1px solid #ccc' }}>
                                                    <TextField
                                                        select
                                                        variant="standard"
                                                        fullWidth
                                                        size="small"
                                                        value={config.tipo_alerta}
                                                        onChange={(e) => updateNewNotificationConfig(config.id, 'tipo_alerta', e.target.value)}
                                                        SelectProps={{
                                                            native: true,
                                                        }}
                                                        InputProps={{ disableUnderline: true }}
                                                    >
                                                        <option value="disconnect">Desconexión</option>
                                                        <option value="reconnect">Reconexión</option>
                                                        <option value="marca_silence">Sin Marcas</option>
                                                    </TextField>
                                                </td>
                                                <td style={{ padding: '8px', border: '1px solid #ccc' }}>
                                                    <TextField
                                                        variant="standard"
                                                        fullWidth
                                                        size="small"
                                                        value="Email"
                                                        disabled
                                                        InputProps={{ disableUnderline: true }}
                                                    />
                                                </td>
                                                <td style={{ padding: '8px', border: '1px solid #ccc' }}>
                                                    <TextField
                                                        select
                                                        variant="standard"
                                                        fullWidth
                                                        size="small"
                                                        value={config.reloj_id || ''}
                                                        onChange={(e) => updateNewNotificationConfig(config.id, 'reloj_id', e.target.value === '' ? null : parseInt(e.target.value))}
                                                        SelectProps={{
                                                            native: true,
                                                        }}
                                                        InputProps={{ disableUnderline: true }}
                                                    >
                                                        <option value="">Todos</option>
                                                        {dataClocks?.map((reloj) => (
                                                            <option key={reloj.id_reloj} value={reloj.id_reloj}>
                                                                {reloj.serial} - {reloj.descripcion || ''}
                                                            </option>
                                                        ))}
                                                    </TextField>
                                                </td>
                                                <td style={{ padding: '8px', border: '1px solid #ccc' }}>
                                                    <CustomCheck
                                                        forCheck={`notification-enabled-new-${config.id}`}
                                                        checked={config.habilitado}
                                                        onChange={(e) => updateNewNotificationConfig(config.id, 'habilitado', e.target.checked)}
                                                    />
                                                </td>
                                                <td style={{ padding: '8px', border: '1px solid #ccc', textAlign: 'center' }}>
                                                    <IconButton
                                                        size="small"
                                                        color="error"
                                                        onClick={() => removeNewNotificationConfig(config.id)}
                                                        title="Eliminar fila"
                                                    >
                                                        <DeleteIcon fontSize="small" />
                                                    </IconButton>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                            <div style={{ display: 'flex', gap: '8px', marginBottom: '16px' }}>
                                <Button
                                    size="small"
                                    variant="outlined"
                                    color="primary"
                                    onClick={addNewNotificationRow}
                                >
                                    + Agregar fila
                                </Button>
                                {newNotificationConfigs.length > 0 && (
                                    <Button
                                        variant="contained"
                                        color="success"
                                        onClick={saveNotificationConfig}
                                    >
                                        Guardar {newNotificationConfigs.length} configuración(es)
                                    </Button>
                                )}
                            </div>
                            <small style={{ color: '#666' }}>Selecciona "Todos" para aplicar la alerta a todos los relojes</small>
                        </div>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseNotification}>Cerrar</Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default BodyUsers